import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";

const sections = [
  ["Introduction", "Chouhan Taxi Service (\"we\", \"us\", \"our\") respects your privacy. This policy explains how we collect, use and protect the information you share when booking a taxi or contacting us."],
  ["Information We Collect", "When you submit a booking or contact form, we collect your name, phone number, and travel details such as pickup and drop locations, dates and preferences. We collect this information solely to process and confirm your booking."],
  ["How We Use Your Information", "We use your information to confirm bookings, provide our taxi and tour services, contact you about your trip and improve our services. We do not sell or rent your personal information to third parties."],
  ["Data Security", "We take reasonable measures to protect your information against unauthorised access. Booking details are stored securely and accessed only by authorised staff."],
  ["Cookies", "Our website may use basic cookies to improve your browsing experience. You can disable cookies in your browser settings at any time."],
  ["Contact", "If you have any questions about this privacy policy, contact us at 099829 03736 or info@chouhantaxiservice.com."],
];

export default function PrivacyPolicy() {
  return (
    <>
      <Seo title="Privacy Policy | Chouhan Taxi Service" description="Read the privacy policy of Chouhan Taxi Service explaining how we collect and protect your information." path="/privacy-policy" />
      <Breadcrumbs items={[{ label: "Privacy Policy" }]} />
      <section className="section-pad pt-8">
        <div className="container-x max-w-3xl">
          <h1 className="text-3xl sm:text-4xl font-heading font-extrabold text-navy-heading">Privacy Policy</h1>
          <p className="mt-3 text-sm text-slate-400">Last updated: January 2025</p>
          <div className="mt-8 space-y-8">
            {sections.map(([h, b]) => (
              <div key={h}>
                <h2 className="font-heading font-bold text-navy-heading text-xl mb-2">{h}</h2>
                <p className="text-slate-600 leading-relaxed">{b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
